import React from 'react'
import { WhiteBox } from '@/components/Layout'
import { DataLoader } from '@/components/dataLoader'
import context from '@/context'
import LoadingIndicator from '@/components/LoadingIndicator'
import ReportSubmissionGroupNoteList from './list'
import Resx from '@/components/Resx'

const ReportSubmissionGroupNotes = (props) => {
  return (
    <WhiteBox
      collapse={props.collapse}
      collapsed={props.collapsed}
      header={<Resx name='Reporting.Notes' />}>
      <DataLoader
        dataSource={() => context.api.reportSubmissionGroupNoteService.getAll(props.parentId)}
        render={x => x.loading ? <LoadingIndicator /> : <ReportSubmissionGroupNoteList notes={x.data} />
        }
      />
    </WhiteBox>
  )
}

export default ReportSubmissionGroupNotes



// WEBPACK FOOTER //
// ./src/components/reporting/submissions/notes/detail.js